export default "__VITE_ASSET__dCleVEct__"